import { render, staticRenderFns } from "./consignacionServicio.vue?vue&type=template&id=a34f0be8&scoped=true&"
import script from "./consignacionServicio.vue?vue&type=script&lang=js&"
export * from "./consignacionServicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34f0be8",
  null
  
)

export default component.exports